import { makeAutoObservable } from 'mobx';
import { UiStore } from '@/stores/ui';

export class PostsArchiveSidebarStore {
  opened = false;
  clientId: string | null = null;

  constructor(public readonly uiStore: UiStore) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  open(clientId?: string) {
    this.opened = true;
    this.clientId = clientId ?? null;
  }

  close() {
    this.opened = false;
    this.clientId = null;
  }

  toggle(clientId?: string) {
    if (this.opened) {
      this.close();
    } else {
      this.open(clientId);
    }
  }
}
